import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Search } from "./Search";
import {
  receivingDashboardOrders,
  virtualReceivingDashboardOrders
} from "./pagination";
import CreateDiscrepancy from "../Detail/Discrepancies/Create";
import Create from "./Create/Create";
import { resetDiscrepancies } from "../actions";

export class Dashboard extends Component {
  static propTypes = {
    virtual: PropTypes.bool,
    reset: PropTypes.func.isRequired,
    displayModal: PropTypes.bool
  };

  constructor(props) {
    super();
    this.openAndSetRecord = this.openAndSetRecord.bind(this);
    this.search = props.virtual
      ? virtualReceivingDashboardOrders
      : receivingDashboardOrders;
  }

  state = {
    showModal: false,
    open: false,
    removeItem: () => {}
  };

  componentWillReceiveProps({ displayModal }) {
    if (displayModal) {
      this.setState({ showModal: true });
    }
  }

  setRemoveItem = removeItem =>
    this.setState({
      removeItem
    });

  open = () => {
    this.setState({ showModal: true, receivingRecord: null });
  };

  closeModal = () => {
    this.setState({ showModal: false });
    this.props.reset();
  };

  openCreate = () => this.setState({ open: true });

  openAndSetRecord = r =>
    this.setState({
      open: true,
      receivingRecord: Object.assign({}, r, {
        virtually_receiving: this.props.virtual
      })
    });

  close = () => {
    this.setState({ open: false, receivingRecord: null });
  };

  render() {
    const { virtual } = this.props;
    const { showModal, open, receivingRecord } = this.state;

    return (
      <React.Fragment>
        <Search
          openAndSetRecord={this.openAndSetRecord}
          openCreate={this.openCreate}
          setRemoveItem={this.setRemoveItem}
          virtual={virtual}
        />
        <Create
          open={open}
          close={this.close}
          receivingRecord={receivingRecord}
          removeItem={this.state.removeItem}
          virtual={virtual}
        />
        <CreateDiscrepancy
          close={this.closeModal}
          open={showModal}
          virtual={virtual}
        />
      </React.Fragment>
    );
  }
}

export default connect(
  state => ({
    displayModal: state.receivingRecordDetail.getIn([
      "receivingRecord",
      "showModal"
    ])
  }),
  {
    reset: resetDiscrepancies
  }
)(Dashboard);



// WEBPACK FOOTER //
// ./app/modules/Receiving/Dashboard/Dashboard.jsx